import { useButtonsStore } from '../../../store/models';
import useStoreModuleDependency from '../../hooks/useStoreModuleDependency';

function usePrimaryDisplay () {
    const buttonsStore = useButtonsStore();

    async function checkPrimaryDisplay () {
        await buttonsStore.checkHasPrimaryDisplay();
    }

    useStoreModuleDependency({ initStore: checkPrimaryDisplay });

    return {
        primaryDisplayChecked: !!buttonsStore.observed.hasPrimaryDisplay,
        hasPrimaryDisplay: buttonsStore.hasPrimaryDisplay,
        checkPrimaryDisplay,
    };
}

export default usePrimaryDisplay;
